import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import Skeleton from "@material-ui/lab/Skeleton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTheme } from "@material-ui/core/styles";

export function Loader() {
  const theme = useTheme();

  return (
    <div
      css={{
        height: 400,
        backgroundColor: theme.palette.background[1],
      }}
      className="centered-container"
    >
      <CircularProgress css={{ color: theme.palette.primary.main }} />
    </div>
  );
}

export function AppBarLoader() {
  const theme = useTheme();
  return (
    <div
      css={{
        height: 64,
        display: "flex",
        alignItems: "center",
        paddingLeft: 10,
        backgroundColor: theme.palette.background[1],
      }}
    >
      <Skeleton
        variant="text"
        animation="wave"
        width={100}
        height={45}
        css={{ backgroundColor: theme.palette.primary.light }}
      />
    </div>
  );
}

export function TabsLoader() {
  const theme = useTheme();
  return (
    <div
      css={{
        display: "flex",
        padding: 10,
        backgroundColor: theme.palette.background[1],
        ...(theme.bp.lessThan.lg && { marginBottom: theme.spacing(2) }),
      }}
    >
      <Skeleton
        variant="text"
        animation="wave"
        width={80}
        height={40}
        css={{ marginRight: 10 }}
      />
      <Skeleton
        variant="text"
        animation="wave"
        width={80}
        height={40}
        css={{ marginRight: 10 }}
      />
      <Skeleton
        variant="text"
        animation="wave"
        width={80}
        height={40}
        css={{ marginRight: 10 }}
      />
      <Skeleton variant="text" animation="wave" width={80} height={40} />
    </div>
  );
}

export function ImageCarouselLoader() {
  const theme = useTheme();
  const height = theme.bp.lessThan.lg ? 150 : 275;
  const width = theme.bp.lessThan.lg ? 200 : 500;
  const minWidth = width;

  return (
    <div
      css={{
        overflow: "hidden",
        backgroundColor: theme.palette.background[1],
        display: "flex",
      }}
    >
      <Skeleton
        variant="rect"
        animation="wave"
        height={height}
        width={width}
        css={{ margin: `0px ${theme.spacing(1)}px`, minWidth }}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={height}
        width={width}
        css={{ margin: `0px ${theme.spacing(1)}px`, minWidth }}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={height}
        width={width}
        css={{ margin: `0px ${theme.spacing(1)}px`, minWidth }}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={height}
        width={width}
        css={{ margin: `0px ${theme.spacing(1)}px`, minWidth }}
      />
    </div>
  );
}

export function MobileRestaurantInfoLoader() {
  const Root = styled.div((props) => ({
    display: "flex",
    ...(props.theme.bp.lessThan.lg && { marginBottom: props.theme.spacing(2) }),
    backgroundColor: props.theme.palette.background[1],
    padding: 10,
    ...(props.theme.bp.lessThan.lg && { paddingBottom: 15 }),
  }));
  const Container = styled.div({
    display: "flex",
  });
  const w1 = Math.floor(Math.random() * 50) + 80;
  const w2 = Math.floor(Math.random() * 150) + 80;
  const w3 = Math.floor(Math.random() * 70) + 30;

  return (
    <Root>
      <Container>
        <div>
          <Skeleton
            variant="rect"
            animation="wave"
            height={90}
            width={90}
            css={{ marginRight: 10 }}
          />
        </div>
        <div>
          <Skeleton
            variant="text"
            animation="wave"
            style={{ height: 45, width: w1, marginBottom: 10 }}
          />
          <Skeleton variant="text" animation="wave" style={{ width: w2 }} />
          <Skeleton variant="text" animation="wave" style={{ width: w3 }} />
        </div>
      </Container>
    </Root>
  );
}

export function Spinner() {
  const theme = useTheme();
  return (
    <div
      css={{
        backgroundColor: theme.palette.background[1],
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress css={{ color: theme.palette.primary.light }} />
    </div>
  );
}

export function MobileLoader() {
  return (
    <div
      css={{
        display: "grid",
        gridTemplateRows: "auto auto auto 1fr auto",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        overflow: "hidden",
      }}
    >
      <AppBarLoader />
      <ImageCarouselLoader />
      <MobileRestaurantInfoLoader />
      <Spinner />
      <TabsLoader />
    </div>
  );
}

export function DesktopLoader() {
  const theme = useTheme();

  return (
    <div
      css={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "grid",
        gridTemplateRows: "1fr",
      }}
    >
      <div
        css={{ height: "100%", width: "100%" }}
        className="centered-container"
      >
        <CircularProgress css={{ color: theme.palette.primary.light }} />
      </div>
    </div>
  );
}
